import React from 'react';
import './style.scss';

export type FormGroupErrorContextProps = {
  error?: React.ReactNode | boolean;
  errorId?: string;
};

export const FormGroupErrorContext = React.createContext<Partial<FormGroupErrorContextProps>>({});

export interface FormGroupProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  tag?: React.ElementType;
  legend?: React.ReactNode;
  description?: React.ReactNode;
  error?: React.ReactNode | boolean;
  errorId?: string;
  withoutErrorPropagation?: boolean;
}
